module.exports = __webpack_public_path__ + "img/red_packet.7cf4a340.png";